import Vue from 'vue'
import Vuex from 'vuex'
import student from './modules/student'
import Util from '@/util/Util'
import exam from './modules/exam'
import { login, sso, checkNewTask, setJoinTime, permission } from '@/api/index'
import NoSleep from 'nosleep.js/dist/NoSleep.min.js'

const Config = window.ConfigNew
const errDCfg = {
  getCurrentPage: 'common',
  needCancleIcon: true,
  showConfirmleBtn: false,
  cancleBtnStyle: 'btn-white',
  showBigTileFlag: false,
  titleIcon: 'warning',
  assistTitleStyle: 'big'
}
const ssoCfg = {
  getCurrentPage: 'sso'
}
const newTaskCfg = {
  getCurrentPage: 'newTask'
}

const storeIndex = {
  state: {
    offline: false, // 离线
    hasMic: 1, // 设备检测，是否有麦克风
    isSidebarDetectionPass: true,
    isShowPromoteD: false, // 晋级 升年级弹窗状态
    isShowErrD: false, // ajax报错
    dCfg: {},
    isShowSsoD: false,
    ssoCfg: Object.assign({}, ssoCfg), // 单点登陆
    isShowNewTaskD: false,
    newTaskCfg: Object.assign({}, newTaskCfg), // 新作也新测评
    isShowCharge: false, // 是否显示VIP付费窗口
    isShowVip2: false, // 是否显示提示非VIP用户只能一次答题
    isEnd4Vip2: false, // 是否为重做
    isShowVip3: false,
    isShowVip4: false,
    isRealVip: false, // 是否传统意义上的vip
    isVIP: false, // 是否能用VIP
    vipTime: '',
    remainingTime: 365,
    vipUntilGraduation: false,
    vipExpiredShow: false,
    neverVip: false,
    identifyStatus: false,
    vipExpireDayAlter: 0,
    notices: '',
    permission: '',
    nosleep: new NoSleep(),
    popup: {},
    isCptRoomVip: false // 是否配置了机房版vip
  },
  actions: {
    oss(context, data) {
      let res = JSON.parse(decodeURIComponent(data)).param
      let _token = localStorage.getItem('socketToken')
      if (res.token !== _token) {
        context.state.ssoCfg = Object.assign({}, ssoCfg, {
          showAssistTitleText: res.loginDateTime,
          cancleBtnCallBack: function() {
            context.state.isShowSsoD = false
            location.href = '/login'
          },
          confirmBtnCallBack: function(writeLog) {
            let identity = 'student'
            let username = Util.getCookieValue('username')
            let password = Util.getCookieValue('password')

            if (!identity || !username || !password) {
              location.href = '/login'
            } else {
              login(
                {
                  identity: identity,
                  username: username,
                  password: password
                },
                res => {
                  if (res.status === 1) {
                    sso({ token: _token })
                    context.state.isShowSsoD = false

                    Util.setCookie('identity', identity)
                    Util.setCookie('username', username)
                    Util.setCookie('password', password)

                    writeLog({ action: '/' + identity + '/login' })

                    sessionStorage.setItem('id', res.id)
                  } else {
                    context.state.isShowSsoD = false
                    location.href = '/login'
                  }
                }
              )
            }
          }
        })
        context.state.isShowSsoD = true
      }
    },
    checkNewTask(context) {
      checkNewTask(
        {
          t: new Date().getTime()
        },
        result => {
          if (result.status === 1) {
            let res = result.data
            if (res.type) {
              if (res.type === 'competition') {
                context.state.newTaskCfg = Object.assign({}, newTaskCfg, {
                  type: res.type,
                  title: '测评',
                  textGreen: res.info.competitionName || '',
                  text1: res.info.endDateTimeTip || '',
                  text2: res.info.submitTimes || '',
                  cancleBtnCallBack: function() {
                    context.state.isShowNewTaskD = false
                  },
                  confirmBtnCallBack: function() {
                    setJoinTime(
                      {
                        stage_id: res.info.stageId
                      },
                      result => {
                        const stu = student.state
                        const query =
                          'competitionId=' +
                          res.info.competitionId +
                          '&groupId=' +
                          res.info.groupId +
                          '&stageId=' +
                          res.info.stageId +
                          '&modelId=' +
                          res.info.modeId +
                          '&checkdevice=' +
                          (+res.info.paper.paperCgy === 7 ? '0' : '1') +
                          '&user=' +
                          stu.phone +
                          '&name=' +
                          encodeURIComponent(stu.name) +
                          '&gender=' +
                          stu.gender +
                          '&stuSchool=' +
                          encodeURIComponent(stu.school) +
                          '&fromUrl=' +
                          encodeURIComponent(
                            (location.pathname + location.search)
                              .replace(/\?/g, '{{q}}')
                              .replace(/&/g, '{{a}}')
                          )

                        if (
                          [1, 4].indexOf(parseInt(res.info.competitionType)) > -1 &&
                          parseInt(res.info.answerProcess) === 1
                        ) {
                          window.location.href = `/web/models/ExamFormal/index.php?${query}`
                        } else {
                          window.location.href = `/practice/exam?${query}&competitionName=${res.info.competitionName}`
                        }
                      }
                    )
                  }
                })
              } else {
                context.state.newTaskCfg = Object.assign({}, newTaskCfg, {
                  type: res.type,
                  title: '练习',
                  textGreen: res.info.worksetName || '',
                  text1: res.info.practiceName || '',
                  text2: res.info.endDateTimeTip || '',
                  cancleBtnCallBack: function() {
                    context.state.isShowNewTaskD = false
                  },
                  confirmBtnCallBack: function() {
                    const query = `isTask=1&worksetId=${res.info.worksetId}&layerType=${res.info.layerType}&layerId=${res.info.layerId}&categoryId=${res.info.categoryId}&teacherId=${res.info.teacherId}`
                    window.location.href = `/practice/work?${query}`
                  }
                })
              }
              context.state.isShowNewTaskD = true
            }
          }
          // context.state.newTaskTime = 10
          context.state.newTaskTime = Config.newTaskTime

          context.dispatch('newTaskLoop')
        }
      )
    },
    newTask(context) {
      if (context.state.isVIP) {
        context.dispatch('checkNewTask')
      } else {
        permission({}, res => {
          if (res.permission === 'allow') {
            context.dispatch('checkNewTask')
          }
        })
      }
    }
  },
  mutations: {
    onlineStatus(state, status) {
      state.offline = status === 'offline'
    },
    initAiPanel(state, callbacks) {
      window.chivoxPlayer = state.$player = new window.Html5Player()

      if (state.$recorder) {
        state.$recorder.dispose()
      }
      let sigurl = window.ConfigNew.sdk.sigurl
      window.ConfigNew.sdk.sigurl =
        (sigurl.match('http') ? '' : localStorage.getItem('zyUrl')) + sigurl

      let { callback, onMicErr, notCheckMic, recordStopCB, onErr } = callbacks || {}
      const recorder = new window.Html5Recorder(
        Object.assign({}, Config.sdk, {
          onInit: function(mess) {
            console.debug('初始化成功', mess)
            typeof callback === 'function' && callback()
          },
          onError: function(err) {
            var code = err.id
            var message = err.message
            console.log('onError: [' + code + ']' + message)

            state.PRStatus = 'idle'
            state.hasMic = +code !== 50003 ? 1 : 0
            if (+code === 50003) {
              typeof onMicErr === 'function' && onMicErr() // 麦克风状态报错
            } else if (+code === 70002) {
              typeof recordStopCB === 'function' && recordStopCB() // 录音因错误停止回调
              recorder.stopRecord()
            } else {
              typeof onErr === 'function' && onErr() // 其他报错
            }
          }
        })
      )
      recorder.stop = recorder.stopRecord

      if (!notCheckMic) {
        state.$recorder = recorder
      }
    },
    avatar(state, url) {
      state.avatar = (url.match(/https?:\/\//) ? '' : Config.resUrl) + url
    },
    showErrDialog(state, param) {
      state.dCfg = Object.assign({}, errDCfg, {
        showAssistTitleText: param.errText,
        cancleBtnText: param.btnText,
        cancleBtnCallBack:
          param.cancleBtnCallBack ||
          function() {
            state.isShowErrD = false
          }
      })
      state.isShowErrD = true
    },
    setPromoteD(state, status) {
      state.isShowPromoteD = status
    },
    toggleChargeModel(state) {
      state.isShowCharge = !state.isShowCharge
    },
    toggleVip2Model(state, isEnd) {
      console.log(state, isEnd)
      state.isShowVip2 = !state.isShowVip2
      state.isEnd4Vip2 = isEnd
    },
    toggleVip3Model(state, a) {
      state.isShowVip3 = a === false ? a : true
    },
    toggleVip4Model(state, a) {
      state.isShowVip4 = a
    },
    setPermission(state, a) {
      console.log(a)
      state.permission = a
    },
    setVipInfo(state, vipInfo) {
      const { isExpired, isVip, expiredDate, vipDays, vipExpiredShow, isCptRoomVip, vipUntilGraduation } = vipInfo
      state.neverVip = vipDays === 0 && isVip === 0
      state.vipExpiredShow = vipExpiredShow
      state.isCptRoomVip = !!isCptRoomVip
      state.isRealVip = !isExpired
      state.isVIP = state.isRealVip || state.isCptRoomVip
      state.vipTime = expiredDate
      state.remainingTime = vipExpiredShow ? vipDays || 0 : 365
      state.vipExpireDayAlter = vipInfo.vipExpireDayAlter
      state.vipUntilGraduation = vipUntilGraduation
      localStorage.setItem('certified', state.student.certified)
      localStorage.setItem('isVIP', state.isVIP)
    },
    setCoefficient(state, info) {
      state.coefficient = info
    },
    setJF(state, info) {
      state.isJF = info
    },
    setNotices(state, info) {
      state.notices = info
      localStorage.setItem('notices', state.notices)
    },
    setPopup(state, popup) {
      state.popup = popup
    },
  },
  modules: {
    student,
    exam
  }
}

Vue.use(Vuex)
export default new Vuex.Store(storeIndex)



// WEBPACK FOOTER //
// ./src/store/index.js